export const viewTitle = "Реестр версий справочников видов документов";
export const viewUniqKey = "version-catalog";
